import { useMutation } from '@tanstack/react-query'
import { calculateKPR } from "./api"

export const useCalculateKPR = (options = {}) => {
  return useMutation({
    mutationKey: ['calculateKPR'],
    mutationFn: ({ params, slug }) => calculateKPR({ params, slug }),
    ...options
  })
}